<template>
    <div class="fullwidth--background">
        <div class="container">
            <div class="container-offset">
                <h1 class="heading--lg heading">BONUS<br/>XP</h1>
                <div class="gradient-line"></div>
            </div>
            <div class="bonus--grid__wrapper">
                <span class="sub-header">Of course making games is already a lot of fun.<br/> But there's much more to enjoy about living here!  </span>

                <div class="perksGrid--wrapper">
                    <bonus-grid-asset v-for="(bonus, index) in bonuses" :key="bonus.id" :img-src="bonus.img"
                                      :heading="bonus.heading" :text="bonus.text"></bonus-grid-asset>
                </div>
                <div class="long--gradient-line"></div>
            </div>
        </div>
    </div>
</template>

<script>
  import bonuses from "../../assets/data/bonuses";
  import BonusGridAsset from "./BonusGridAsset";
  import ContainerWithOffset from "../../components/common/ContainerWithOffset";

  export default {
    name: "BonusGrid",
    components: { BonusGridAsset, ContainerWithOffset },
    data() {
      return {
        bonuses
      };
    }
  };
</script>

<style scoped lang="scss">
    @import "../../assets/scss/main";

    .container {
        margin-bottom: 0 !important;
    }

    .fullwidth--background {
        background-image: url("/static/img/backgrounds/expats/bonusxp_background.png");
    }

    .perksGrid--wrapper {
        margin-top: 115px;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
        grid-gap: 58px;

        @media (max-width: 1200px) {
            grid-gap: 30px;
        }

        @media (max-width: $compact) {
            margin-top: 55px;
        }
    }

    .bonus--grid__wrapper {
        padding: 1em;
        margin-bottom: 0;
    }

    .container {
        margin-bottom: 200px;

        @media (max-width: $compact) {
            margin-bottom: 50px;
        }
    }

    .heading {
        color: white;
    }

    .sub-header {
        color: $text-blue;


        @media (max-width: $tablet) {
            font-size: 24px;
        }
    }

    .container-offset {
        display: flex;
        justify-content: space-between;
        margin-top: -215px;
        padding: 7em;
        padding-bottom: 5em;
        padding-top: 94px;
        margin-bottom: 90px;
        margin-left: -96px;
        margin-right: -96px;

        background: $mine-shaft;
        position: relative;
        z-index: 10;

        @media (max-width: $mq-xl) {
            max-width: none;
            padding: 1em;
            margin-top: -20px !important;
            margin-left: 0;
            margin-right: 0;
            padding: 2em;
        }

        @media (max-width: $compact) {
            margin-bottom: 16px;
            flex-direction: column;
        }
    }

    .long--gradient-line {
        width: 100%;
        height: 3px;
        background: #02b5f2;
        margin-top: 94px;
        margin-bottom: 94px;

        @media (max-width: $compact) {
            margin-top: 47px;
            margin-bottom: 40px;
        }
    }

    .gradient-line {
        width: 579px;
        height: 9px;
        background-image: linear-gradient(to right, rgba(0, 186, 136, 0.9) 0%, rgba(0, 181, 242, 0.9) 100%);
        align-self: flex-end;

        @media (max-width: $compact) {
            height: 5px;
            width: 100%;
            margin-top: 21px;

        }
    }

</style>


// WEBPACK FOOTER //
// src/components/expatsPageComponents/BonusGrid.vue